/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import { PhrMeasurement, PhrMeasurementFromJSON, PhrMeasurementFromJSONTyped, PhrMeasurementToJSON } from "./";

export const PhrHDLCholesterolsTypename = "PhrHDLCholesterols" as const;

/**
 *
 * @export
 * @interface PhrHDLCholesterols
 */
export interface PhrHDLCholesterols {
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrHDLCholesterols
   */
  other?: PhrMeasurement;
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrHDLCholesterols
   */
  ultravioletVisibleAbsorptionSpectroscopy?: PhrMeasurement;
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrHDLCholesterols
   */
  visibleAbsorptionSpectrophotometry?: PhrMeasurement;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrHDLCholesterols
   */
  readonly __typename?: string;
}

export function PhrHDLCholesterolsFromJSON(json: any): PhrHDLCholesterols {
  return PhrHDLCholesterolsFromJSONTyped(json, false);
}

export function PhrHDLCholesterolsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrHDLCholesterols {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrHDLCholesterolsTypename,

    other: !exists(json, "other") ? undefined : PhrMeasurementFromJSON(json["other"]),
    ultravioletVisibleAbsorptionSpectroscopy: !exists(json, "ultraviolet_visible_absorption_spectroscopy")
      ? undefined
      : PhrMeasurementFromJSON(json["ultraviolet_visible_absorption_spectroscopy"]),
    visibleAbsorptionSpectrophotometry: !exists(json, "visible_absorption_spectrophotometry")
      ? undefined
      : PhrMeasurementFromJSON(json["visible_absorption_spectrophotometry"]),
  };
}

export function PhrHDLCholesterolsToJSON(object?: PhrHDLCholesterols | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    other: PhrMeasurementToJSON(value.other),
    ultraviolet_visible_absorption_spectroscopy: PhrMeasurementToJSON(value.ultravioletVisibleAbsorptionSpectroscopy),
    visible_absorption_spectrophotometry: PhrMeasurementToJSON(value.visibleAbsorptionSpectrophotometry),
  };
}
